module.exports = __webpack_public_path__ + "img/yptx2.c938b0ac.png";